/* istanbul ignore file */
import styled from 'styled-components';

export const ChildComponentTitle = styled.h1`
  color: ${({ theme }) => theme.neutral};
  font-family: Museo Sans, sans-serif;
  font-size: 22.5px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
  margin-top: 0;
`;
